import { useContext } from "react";
import { PluginContext } from "../providers";

/**
 * Hook that returns the plugin context value
 * 
 * @returns The plugin context
 */
const usePlugin = () => {
  const pluginContext = useContext(PluginContext);

  if (!pluginContext) {
    throw new Error("usePlugin must be used within an PluginProvider");
  }
  return pluginContext;
};

export default usePlugin;
